import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Director 13 Oct 2026: shown in Admin whenever any account is inside its 30-day pending-deletion period. No addresses - id prefixes only.
export const PendingDeletionBanner = ({ token, onOpen }) => {
  const [pending, setPending] = useState([]);

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/admin/deleted-accounts`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setPending(r.data.pending_deletion_period || []))
      .catch(() => setPending([]));
  }, [token]);

  if (!pending.length) return null;
  const earliest = pending.map((p) => p.purge_due).filter(Boolean).sort()[0];
  return (
    <div className="bg-amber-500 text-amber-950" data-testid="pending-deletion-banner" role="status">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center gap-3 text-sm">
        <span className="inline-flex items-center justify-center min-w-[1.5rem] h-6 px-2 rounded-full bg-amber-950 text-amber-50 font-bold" data-testid="pending-deletion-count">{pending.length}</span>
        <span className="font-semibold">
          {pending.length === 1 ? 'Account' : 'Accounts'} in the 30-day pending-deletion period:{' '}
          <span className="font-mono" data-testid="pending-deletion-ids">{pending.map((p) => p.account_id_prefix).join(' · ')}</span>
          {earliest && <> — earliest purge due <span data-testid="pending-deletion-earliest">{earliest.slice(0, 10)}</span></>}
        </span>
        <Button size="sm" variant="secondary" className="rounded-full ml-auto" onClick={onOpen} data-testid="pending-deletion-open-users">Open Users</Button>
      </div>
    </div>
  );
};
